import { Stack } from "@mui/material";
import { useTranslation } from "react-i18next";
import { TabsContentProps } from "./TabsContent.types";
import { CardLinks } from "..";
import { TitleAndSubtitle } from "../../components/Commons/TitleAndSubtitle.component";

export function ResourcesContent({
  contentLinks,
  contentTools,
  currentLO,
  title,
  titleSubtitleVisible=true
} :
  & (
    | Required<
      | Pick<
        TabsContentProps,
        | "contentLinks"
      > & { contentTools: undefined }
    >
    | Required<
      | Pick<
        TabsContentProps,
        | "contentTools"
      > & { contentLinks: undefined }
    >
    | Required<
      Pick<
        TabsContentProps,
        | "contentLinks"
        | "contentTools"
      >
    >
  )
  & Pick<
    TabsContentProps,
    | "currentLO"
  >
  &  {
    title?: string,
    subTitle?: string,
    titleSubtitleVisible?: boolean
  }
) {
  const { t } = useTranslation();

  const isDisabled =
    currentLO
      ? (currentLO?.learningObjectType === "ASYNC" || currentLO?.learningObjectType === "BLENDED")
        ? currentLO.status === "N" && currentLO.enrollType === "TOP_DOWN"
        : currentLO.status === "N"
      : true;

  return (
    <Stack
      width={ "100%" }
    >
      { titleSubtitleVisible && <TitleAndSubtitle sxSubTitle={ { marginBottom:"2rem" } }
        title={ title }
        subTitle={ t("doc_text") }
      /> }
      <CardLinks
        cardTabsLinks={ contentLinks }
        cardTabsTools={ contentTools }
        disabled={ isDisabled }
      />
    </Stack>
  );
}
